"use client";
import React, { FC } from "react";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";

// components
import { ScanQrCode, Notifications, SwitchLanguage, UserMenu } from "./";
import { getPageTitle } from "@/utils/getPageTitle";

const Header: FC = () => {
  const t = useTranslations();
  const pathname = usePathname();

  return (
    <header className="fixed right-0 top-0 z-[100] flex w-full items-center justify-between rounded-tl-[32px] border-b border-zinc-100 bg-[#f9f9f9] px-10 py-7 lg:w-[82%]">
      <h1 className="hidden text-3xl font-bold text-[#121212] md:inline">
        {t(getPageTitle(pathname))}
      </h1>
      <div className="flex items-center gap-4">
        <ScanQrCode />
        <div className="h-[30px] border border-[#f1f1f1]" />
        <Notifications />
        <SwitchLanguage />
        <UserMenu />
      </div>
    </header>
  );
};

export default Header;
